import React from 'react';
import { EditableColumnType } from 'components/CustomTable/CustomTable';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import CustomSelect from 'components/CustomSelect';
import { IEntityRole } from 'store/ducks/DataManagement/Article8AndICTSystem/types';
import * as Styled from '../Tables/DataEntry/DataEntry.styled';

export const getEntityRoleColumns = (
  handleSave: (record: IEntityRole) => void,
  handleAddRow: (record: { key: React.Key }, index: number) => void,
  handleRemoveRow: (key: number) => void,
  handleInactivate: (record: IEntityRole) => void,
  roleTypes: { value: string; label: string }[],
  t: any,
): EditableColumnType[] => [
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('ENTITY_ROLE.ROLE_NAME')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'role_name',
    editable: true,
    fixed: 'left',
  },
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('ENTITY_ROLE.ROLE_TYPE')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'dependency_type_id',
    editable: false,
    render: (_, record) => (
      <CustomSelect
        options={roleTypes}
        value={record.role_type_id}
        onChange={(value: any, option: { label: string }) =>
          handleSave({
            ...record,
            role_type_id: value,
            role_type_name: option?.label,
          } as IEntityRole)
        }
        filterOption={(input: string, option: { label: string }) =>
          option?.label?.toLowerCase().includes(input.toLowerCase())
        }
      />
    ),
  },
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('ENTITY_ROLE.DESCRIPTION')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'description',
    editable: true,
  },
  {
    title: t('GENERAL.ACTIONS'),
    key: 'actions',
    width: 150,
    render: (_: any, record) => (
      <>
        {record.isNew ? (
          <Button danger onClick={() => handleRemoveRow(record.key)}>
            {t('GENERAL.REMOVE')}
          </Button>
        ) : (
          <Button
            danger
            onClick={() => handleInactivate(record as IEntityRole)}
          >
            {t('GENERAL.SOFT_DELETE')}
          </Button>
        )}
      </>
    ),
  },
];
